/**
 * Parse a canonical dataset key of the form:
 *
 *   imagery.permian.delaware.2024_08        (month precision)
 *   imagery.permian.midland.2025_12_13      (day precision)
 *
 * Returns:
 *   {
 *     key: "imagery.permian.midland.2025_12_13",
 *     slug: "imagery.permian.midland",
 *     date: "2025_12_13"
 *   }
 *
 * Returns null if invalid.
 *
 * ── THE DAY IS OPTIONAL, AND THIS REGEX IS WHY IT USED TO BE IMPOSSIBLE ─────
 *
 * The pattern was `\d{4}_\d{2}` with no day, and a non-match returns null.
 * api/tileTokens.js bails on a null parse before it reaches /tile/session, so
 * a dataset whose key did not fit produced NO TILE TOKEN, no `ck`, and no tile
 * URL — MapLibre simply never requested anything. The layer toggled and the
 * network stayed silent, which reads like a rendering problem and is a regex.
 * That cost an afternoon on 2026-09-02, so it is written down here.
 *
 * IT ALSO CAPPED INGEST AT ONE COLLECT PER MONTH per basin/region. That limit
 * was never in S3 and never in the database — `datasets` is unique on
 * (slug, acquisition_date) and would happily hold two days in one month, and
 * the ingest's --collect flag addresses the S3 folder independently. The only
 * thing forbidding a second December collect was this line.
 *
 * The day is OPTIONAL rather than required so existing month-precision keys —
 * 2025_06, 2025_09 — keep parsing. Both precisions sort correctly under the
 * string comparisons in resolveImageryStack.js and effectiveDate.js, because
 * zero-padded YYYY_MM[_DD] is lexicographically ordered.
 */
export function parseDatasetKey(key) {
  if (typeof key !== "string") return null;

  // Canonical shape: slug + YYYY_MM, with an optional _DD.
  const m = key.match(
    /^([a-z0-9._-]+)\.(\d{4}_\d{2}(?:_\d{2})?)$/
  );

  if (!m) return null;

  const [, slug, date] = m;

  return {
    key,
    slug,
    date,
  };
}